export { default } from "./ModalWithTrigger";
